export interface OpenHomeTime {
    date: Date;
    startTime: number;
    endTime: number;
}
